const FALLBACK = [
  "LOWLANDS 2027",
  "DEFQON.1",
  "HYROX AMSTERDAM",
  "PINKPOP",
  "AWAKENINGS ADE",
  "NOOIT MEER TE LAAT",
];

export const Marquee = ({ items }) => {
  const content = items && items.length ? items : FALLBACK;
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-white/10 bg-[#0D0D12] py-3.5"
    >
      <div className="flex w-max animate-marquee">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center" aria-hidden={half === 1}>
            {content.map((t, i) => (
              <span
                key={`${half}-${i}`}
                className="flex items-center gap-6 px-6 font-mono text-[11px] uppercase tracking-[0.3em] text-slate-500"
              >
                <span className="h-1.5 w-1.5 shrink-0 animate-pulse rounded-full bg-volt" />
                {t}
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
